import React from "react";
import propTypes from "prop-types";
import PolicyCardWrapper from "./index.styles";

import { Card } from "primereact/card";
import { RadioButton } from "primereact/radiobutton";
import { useTranslation } from "react-i18next";
import { useDispatch,  } from "react-redux";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { BUSINESS_LINE_COLORS, BUSINESS_LINE_PATHS } from "helpers/utils";

const SubCard = (props) => {
  const { policyDetails, activeCard, onCardActive, totalPrice, claimAmount } = props;
  const { t, i18n } = useTranslation();
  const showRTL = i18n.dir() === "rtl";

  const dispatch = useDispatch();
  //   const { title, totalPrice, orignalPrice, currency, annualClaim } = policyDetails;

  //   const [claimAmount, setClaimPrice] = useState(0);
  //   const [vat, setVatPrice] = useState();
  //   const [selectedIndemnity, updateSelectedIndemnity] = useState(0);

  const { businessLine } = useParams();

  // REBRANDING COLORS
  let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
  if (businessLine === BUSINESS_LINE_PATHS.LEAN) businessColor = BUSINESS_LINE_COLORS.LEAN;

  //const claimAmount = props.claimAmount;

  useEffect(() => {}, []);

  return (
    <PolicyCardWrapper businessColor={businessColor}>
      <Card
        header={
          <div className={totalPrice ? "header-height-discount" : "header-height"}>
            <div className="row price-area">
              <div className="headerText">
                <div className={"title font-bliss " + (activeCard ? "activeColor" : "")}>
                  {totalPrice} <span>{t("POLICY.SAR")}</span>
                </div>
                <div className={"subtitleText " + (activeCard ? "activeColor opcity" : "")}>
                {t("MotorEn.Deductible")}                
                </div>
              </div>
            </div>
          </div>
        }
        className={activeCard ? "activeCard" : "card"}
        onClick={e => onCardActive(totalPrice)}
      >
        <div className="row content align-items-end">
          <div className="col-md-8 claim-price">
            <div className={"vat " + (activeCard ? "activeColor opcity" : "")}>
              {t("Motor.owen_damage")}
              <br />
              {t("Motor.Sanad_limit")}
            </div>

            <div className={"amount d-inline " + (activeCard ? "activeColor" : "")}>
              {claimAmount + " "}
            </div>
            <div className={"currency d-inline " + (activeCard ? "activeColor" : "")}>
              {t("POLICY.SAR")}
            </div>
          </div>
          <div className={!showRTL ? "col-md-4 radio text-end" : "col-md-4 radio-rtl text-end"}>
            <div className={"radioDiv"}>
              <RadioButton checked={activeCard} />
            </div>
          </div>
        </div>
      </Card>
    </PolicyCardWrapper>
  );
};

SubCard.propTypes = propTypes.exact({
  policyDetails: propTypes.object.isRequired,
  activeCard: propTypes.bool.isRequired,
  onCardActive: propTypes.func.isRequired,
  totalPrice: propTypes.func.isRequired,
  claimAmount: propTypes.func.isRequired,
}).isRequired;

export default SubCard;
